module.exports = __webpack_public_path__ + "img/logo_Qualitas.dcbe1189.svg";